import React from "react";

type Props = {
  onContinue: () => void;
};

export default function ThankYouSimple({ onContinue }: Props) {
  return (
    <div className="min-h-screen bg-[#FFFDF5] pt-36 pb-24 px-6 flex items-center justify-center">
      <div className="max-w-xl w-full bg-white rounded-[3rem] shadow-2xl border border-black/[0.03] p-10 md:p-16 text-center grainy">
        <div className="text-5xl mb-6">✅</div>

        <h1 className="text-4xl md:text-5xl font-black serif tracking-tight">
          You’re in.{" "}
          <span className="text-amber-600 italic">Welcome.</span>
        </h1>

        <p className="mt-6 text-gray-500 font-medium leading-relaxed">
          Your account is created and your subscription is active.
          <br />
          Next step: complete your venue profile so your specials look great in search.
        </p>

        <div className="mt-10 space-y-4">
          <button
            onClick={onContinue}
            className="w-full h-16 bg-amber-500 text-black rounded-2xl font-black uppercase tracking-widest hover:bg-black hover:text-amber-500 transition-all shadow-xl"
          >
            Set Up Venue Profile
          </button>

          <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">
            Step 1 – Set Up Profile · Step 2 – List Specials
          </p>
        </div>
      </div>
    </div>
  );
}
